import { apiClient } from './api-client';

export interface ServiceType {
  id: string;
  tenantId: string;
  code: string;
  name: string;
  description: string | null;
  isBillable: boolean;
  requiresApproval: boolean;
  allowsBerAssessment: boolean;
  requiresCommercialReviewDefault: boolean;
  isWarrantyEligible: boolean;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceTypeListResponse {
  items: ServiceType[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateServiceTypePayload {
  code: string;
  name: string;
  description?: string;
  isBillable?: boolean;
  requiresApproval?: boolean;
  allowsBerAssessment?: boolean;
  requiresCommercialReviewDefault?: boolean;
  isWarrantyEligible?: boolean;
}

export type UpdateServiceTypePayload = Partial<CreateServiceTypePayload> & { isActive?: boolean };

export const serviceTypeService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<ServiceTypeListResponse> =>
    apiClient.get<ServiceTypeListResponse>('/service-types', { params }).then((r) => r.data),

  listAll: (): Promise<ServiceType[]> =>
    apiClient
      .get<ServiceTypeListResponse>('/service-types', { params: { pageSize: 100 } })
      .then((r) => r.data.items),

  create: (payload: CreateServiceTypePayload): Promise<ServiceType> =>
    apiClient.post<ServiceType>('/service-types', payload).then((r) => r.data),

  update: (id: string, payload: UpdateServiceTypePayload): Promise<ServiceType> =>
    apiClient.patch<ServiceType>(`/service-types/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/service-types/${id}`).then(() => undefined),
};
